export default __webpack_public_path__ + "static/media/BgGroup38519.f8923db0.png";